import { Controller } from "@hotwired/stimulus"

// The add drawer's suggested-tag chips (#3263): fetched as the link is
// typed, debounced, for a page the bucket already knows. The chips land
// inside the tags field, whose tom-select controller presses them.
export default class extends Controller {
  static targets = ["url", "output"]
  static values = { url: String, delay: { type: Number, default: 400 } }

  connect() {
    if (this.urlTarget.value.trim()) this.#fetch()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  refresh() {
    // The link changed: chips showing, or still on their way, are for the
    // old one and must not outlive it, even inside the debounce
    this.latest = null
    this.outputTarget.innerHTML = ""
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.#fetch(), this.delayValue)
  }

  async #fetch() {
    const link = this.urlTarget.value.trim()
    if (!/^https?:\/\/\S+\.\S+/i.test(link)) return
    const request = (this.latest = Symbol("request"))
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("url", link)
    const response = await fetch(url, { headers: { Accept: "text/html" } })
    // A redirect is the sign-in page, not chips: the session can expire
    // under an open drawer
    if (!response.ok || response.redirected) return
    const html = await response.text()
    // Re-checked after the body arrives: a newer request can overtake this
    // one while the body is still streaming
    if (request !== this.latest) return
    this.outputTarget.innerHTML = html
  }
}
